var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_201_116729)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.6695,
    cy: 30.9996,
    r: 27.9,
    fill: "#F3BA2F",
    fillOpacity: 0.12
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4424 28.0293L31.6657 20.806L38.8953 28.0355L43.0981 23.8327L31.6657 12.4004L20.2396 23.8265L24.4424 28.0293ZM13.0664 30.9992L17.2681 26.7975L21.4698 30.9992L17.2681 35.2008L13.0664 30.9992ZM31.6653 41.1948L24.4419 33.9714L20.233 38.1681L20.2391 38.1742L31.6653 49.6004L43.0976 38.1681L38.8948 33.9653L31.6653 41.1948ZM41.8581 31.0016L46.0598 26.7999L50.2615 31.0016L46.0598 35.2033L41.8581 31.0016ZM31.6658 26.7356L35.9305 31.0002L31.6658 35.2711L27.4012 31.0064V30.9941L28.1501 30.2451L28.5153 29.8861L31.6658 26.7356Z",
    fill: "#F3BA2F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_201_116729",
    x: -34.2305,
    y: -34.9004,
    width: 131.801,
    height: 131.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_201_116729"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_201_116729",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/Binance.58e5d327748f65ec1ada4b5afbca37e6.svg";
export { ForwardRef as ReactComponent };